import { useCallback } from 'react';
import omit from 'lodash/omit';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';

export type AnalyticsProps =
	| {}
	// TextArea attributes
	| {
			searchStringLength: number;
	  }
	// Picker attributes
	| {
			selectedItemsCount: number;
			selectedItemIndex: number | undefined;
			selectedItemType?: string;
			isFullList?: boolean;
	  }
	// Date/DateTime attributes
	| {
			timeConstraints: string | undefined;
	  }
	// NumberRange attributes
	| {
			hasMinValue: boolean;
			hasMaxValue: boolean;
	  }
	// CascadeSelect attributes
	| {
			hasParentOption: boolean;
			hasChildOption: boolean;
	  }
	// AQL attributes
	| {
			isAqlValidationEnabled: boolean;
	  };

export const useSendOptionAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return useCallback(
		(attributes: AnalyticsProps): void => {
			const actionSubjectId = 'refinementBarFilterSearch';
			const analyticsEvent = createAnalyticsEvent({
				eventType: 'UI',
				action: 'changed',
				actionSubject: 'filterSearch',
				actionSubjectId,
			});

			fireUIAnalytics(
				analyticsEvent,
				actionSubjectId,
				omit(attributes, 'fieldId'), // ensure we cannot log fieldId attribute (can contain UGC)
			);
		},
		[createAnalyticsEvent],
	);
};
